module.exports = __webpack_public_path__ + "img/autotagging_2.d53b0f07.jpg";